import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import AppContext from "../../../context/Context";
import APICall from "../../../services/apiCall";
import SikkaCardHeader from "../../common/SikkaCardHeader";
import SikkaInput from "../../common/SikkaInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonIcon from "../../common/ButtonIcon";
import ModalCustom from "../../common/ModalCustom";
import "../AccountRecovery/AccountRecovery.css";
import { useHistory } from "react-router-dom";

import apiCall from "../../../services/apiCall";
import authenticationService from "../../../services/authenticationService";
import {
  faCheck,
  faLock,
  faMobileAlt,
  faPencil,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Loader from "../../common/Loader";

const AccountRecoveryModel = () => {
  const { loginUserDetails,isAccountRecoveryModel, setIsAccountRecoveryModel } = useContext(AppContext);
  const history = useHistory();
  const [questions, setQuestions] = useState([]);
  const recoveryNotConfigured = localStorage.getItem("accountRecoveryModel");

  useEffect(() => {
    // get recovery questions
    let params = {
      devid: loginUserDetails.dev_id,
      displayonui: "yes",
    };
    apiCall
      .servertrip(
        "GET",
        "get_account_recovery_questions",
        loginUserDetails,
        params
      )
      .then((res) => {
        setQuestions(res.data.items);
      })
      .catch((error) => {
        
      });
  }, []);

  useEffect(() => {
    if (recoveryNotConfigured) {
      if (
        recoveryNotConfigured == "true" &&
        loginUserDetails?.is_2fa_enabled?.toLowerCase() == "yes"
      ) {
        if (window.location.href.includes("/profile")) {
          setIsAccountRecoveryModel(true);
        } else {
          if (loginUserDetails?.is_partner == "0") {
            history?.push(`${process.env.PUBLIC_URL}/admin/settings/profile`);
          } else {
            history?.push(`${process.env.PUBLIC_URL}/user/settings/profile`);
          }
          setIsAccountRecoveryModel(true);
        }
      } else {
        setIsAccountRecoveryModel(false);
      }
    } else {
      setIsAccountRecoveryModel(false);
    }
  }, [recoveryNotConfigured, window.location.href]);

  return (
    <>
      <ModalCustom
        title={
          <>
            {" "}
            <FontAwesomeIcon
              style={{ marginRight: "5px" }}
              icon={faLock}
              className=""
            />{" "}
            <span className="">
              Account Recovery <span className="text-danger">*</span>
            </span>
          </>
        }
        openPopup={isAccountRecoveryModel}
        setOpenPopup={setIsAccountRecoveryModel}
        size="md"
        centered
        fade={false}
        backdrop={"static"}
        isHeaderCloseBtn={false}
        keyboard={false}
      >
        <Row className="">
          <Col>
            <p className="text-danger ar-text">
              We’ve made account recovery questions mandatory for better
              security and easier account recovery.
            </p>
            {/* <div class="checklist">
              <p>
                <strong>What you need to do:</strong>
              </p>
              <ul>
                <li>Log in to your account</li>
                <li>
                  Go to the <strong>'Account Recovery'</strong> section in your Profile.
                </li>
                <li>
                  Set up <strong>3 recovery questions</strong>
                </li>
              </ul>
            </div> */}

            <p>
              <strong>
                Complete this step now to avoid any login issues in the future!
              </strong>
            </p>
          </Col>
        </Row>
        <Row className="mt-1 mb-2">
          <Col>
            <ButtonIcon
              color="outline-primary"
              size="sm"
              icon="Sync"
              className=""
              iconClassName="fs--2"
              onClick={() => {
                setIsAccountRecoveryModel(false);
              }}
            >
              <FontAwesomeIcon
                style={{ marginRight: "5px" }}
                icon={faLock}
                className=""
              />{" "}
              Secure Your Account
            </ButtonIcon>
          </Col>
        </Row>
      </ModalCustom>
    </>
  );
};

export default AccountRecoveryModel;
